import * as React from "react";

function SvgMoreInfo(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}><path d="M7 0a7 7 0 10.001 14.001A7 7 0 007 0zm0 12.813A5.813 5.813 0 017 1.187a5.813 5.813 0 010 11.626z" /><path d="M6.25 9.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM6.625 8h.75a.125.125 0 00.125-.125v-4.25a.125.125 0 00-.125-.125h-.75a.125.125 0 00-.125.125v4.25c0 .069.056.125.125.125z" /></svg>;
}

export default SvgMoreInfo;